import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { EVENT_QUERIES } from "~/shared/api/events/events.queries";

export async function eventCreateViewLoader({ request }: LoaderFunctionArgs, queryClient: QueryClient) {
  const url = new URL(request.url);
  const eventId = url.searchParams.get("eventId");
  if (!eventId) return null;

  // If there's an event id in the url, we want to grab and prefetch.
  // This data is likely an attempt to "duplicate" an event.
  queryClient.prefetchQuery(EVENT_QUERIES.detail(parseInt(eventId)));

  return null;
}
